const ATTENDEE_ASSET_WIDTH = 1440;
const ATTENDEE_ASSET_HEIGHT = 2125;

function fitAttendeeMediaAsset() {
  document.querySelectorAll('.attendee-media-asset-frame').forEach((frame) => {
    const stage = frame.querySelector('.attendee-media-asset-stage');
    if (!stage) return;

    const scale = Math.min(
      frame.clientWidth / ATTENDEE_ASSET_WIDTH,
      frame.clientHeight / ATTENDEE_ASSET_HEIGHT
    );

    stage.style.transform = `scale(${scale})`;
  });
}

function renderAttendeeMediaAsset(node) {
  const opts = {
    width: ATTENDEE_ASSET_WIDTH,
    height: ATTENDEE_ASSET_HEIGHT,
    pixelRatio: 1.5,
    backgroundColor: '#26174B',
    style: {
      transform: 'none',
      transformOrigin: 'top left',
    },
  };

  return htmlToImage.toPng(node, opts).then(() => htmlToImage.toPng(node, opts));
}

function dataUrlToFile(dataUrl, filename) {
  return fetch(dataUrl)
    .then((response) => response.blob())
    .then((blob) => new File([blob], filename, { type: blob.type || 'image/png' }));
}

function downloadDataUrl(dataUrl, filename) {
  const link = document.createElement('a');
  link.download = filename;
  link.href = dataUrl;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function prefersNativeShare() {
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}

function saveOrShareImage(dataUrl, filename) {
  if (!prefersNativeShare()) {
    downloadDataUrl(dataUrl, filename);
    return Promise.resolve();
  }

  return dataUrlToFile(dataUrl, filename).then((file) => {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      return navigator
        .share({
          files: [file],
          title: filename,
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return;
          downloadDataUrl(dataUrl, filename);
        });
    }

    downloadDataUrl(dataUrl, filename);
  });
}

function generateAttendeeMediaAsset(btn) {
  const node = document.getElementById('attendee-media-asset');
  const photo = document.querySelector('[data-attendee-photo]');
  if (!photo || !photo.getAttribute('src')) {
    alert('Upload a photo first.');
    return Promise.resolve();
  }

  const was = btn ? btn.textContent : null;
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Rendering…';
  }

  return (document.fonts ? document.fonts.ready : Promise.resolve())
    .then(() => renderAttendeeMediaAsset(node))
    .then((dataUrl) => saveOrShareImage(dataUrl, 'shop-quest-attendee.png'))
    .catch((err) => {
      console.error(err);
      alert('Could not render that card. Refresh and try again.');
    })
    .finally(() => {
      if (btn) {
        btn.disabled = false;
        btn.textContent = was;
      }
    });
}

function setAttendeePhoto(file) {
  const photo = document.querySelector('[data-attendee-photo]');
  const uploadLabel = document.querySelector('[data-upload-label]');
  const downloadButton = document.querySelector('[data-download-attendee]');
  if (!photo || !file) return;

  if (photo.dataset.objectUrl) {
    URL.revokeObjectURL(photo.dataset.objectUrl);
  }

  const objectUrl = URL.createObjectURL(file);
  photo.dataset.objectUrl = objectUrl;
  photo.src = objectUrl;
  photo.hidden = false;

  if (uploadLabel) {
    uploadLabel.textContent = file.name || 'Photo selected';
  }

  if (downloadButton) {
    downloadButton.disabled = false;
  }
}

function setAttendeeText(selector, value) {
  const el = document.querySelector(selector);
  if (!el) return;
  el.textContent = (value || '').trim();
}

function setAttendeeName(value) {
  setAttendeeText('[data-attendee-name]', value);
}

function setAttendeeMeta() {
  const designationInput = document.querySelector('[data-attendee-designation-input]');
  const companyInput = document.querySelector('[data-attendee-company-input]');
  const designation = (designationInput?.value || '').trim();
  const company = (companyInput?.value || '').trim();
  const meta = [designation, company].filter(Boolean).join(', ');
  setAttendeeText('[data-attendee-meta]', meta);
}

fitAttendeeMediaAsset();
if (window.ResizeObserver) {
  const observer = new ResizeObserver(fitAttendeeMediaAsset);
  document.querySelectorAll('.attendee-media-asset-frame').forEach((frame) => observer.observe(frame));
} else {
  window.addEventListener('resize', fitAttendeeMediaAsset);
}
window.addEventListener('load', fitAttendeeMediaAsset);

const nameInput = document.querySelector('[data-attendee-name-input]');
if (nameInput) {
  setAttendeeName(nameInput.value);
  nameInput.addEventListener('input', () => setAttendeeName(nameInput.value));
}

const designationInput = document.querySelector('[data-attendee-designation-input]');
if (designationInput) {
  designationInput.addEventListener('input', setAttendeeMeta);
}

const companyInput = document.querySelector('[data-attendee-company-input]');
if (companyInput) {
  companyInput.addEventListener('input', setAttendeeMeta);
}

setAttendeeMeta();

const uploadInput = document.querySelector('[data-attendee-upload]');
if (uploadInput) {
  uploadInput.addEventListener('change', () => {
    const file = uploadInput.files && uploadInput.files[0];
    if (file) setAttendeePhoto(file);
  });
}

const downloadButton = document.querySelector('[data-download-attendee]');
if (downloadButton) {
  downloadButton.addEventListener('click', () => generateAttendeeMediaAsset(downloadButton));
}
